// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/styles/containers/Sources.scss
// module id = 1332
// module chunks = 0